import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationPowerCableForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.MODIFICATION_POWER_CABLE
    >();

    const convertValue = (): string => {
        if (values.modificationPowerCable.value.junctionBoxRelocation)
            return "junctionBoxRelocation";
        if (values.modificationPowerCable.value.junctionBoxAndCableRelocation)
            return "junctionBoxAndCableRelocation";
        if (values.modificationPowerCable.value.cableRelocation) return "cableRelocation";
        if (values.modificationPowerCable.value.junctionBoxReplacement)
            return "junctionBoxReplacement";
        return "";
    };
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Stromnetzanschluss
                </h4>
                <p className={classes.p}>
                    Welche Änderrung soll auf dem Privatgrundstück vorgenommen werden?
                </p>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.modificationPowerCable.value = {
                                    junctionBoxRelocation: v.indexOf("junctionBoxRelocation") >= 0,
                                    junctionBoxAndCableRelocation:
                                        v.indexOf("junctionBoxAndCableRelocation") >= 0,
                                    cableRelocation: v.indexOf("cableRelocation") >= 0,
                                    junctionBoxReplacement:
                                        v.indexOf("junctionBoxReplacement") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            value="junctionBoxRelocation"
                            control={<Radio />}
                            label="Versetzen des Hausanschlusskastens im gleichen Raum (bis 3m)"
                            text=""
                            error={values.modificationPowerCable.error != null}
                        />
                        <FormControlLabel
                            value="junctionBoxAndCableRelocation"
                            control={<Radio />}
                            label="Versetzen des Hausanschlusskastens und Umlegung des Netzanschlusskabel inkl. neuer Gebäudeeinführung"
                            text=""
                            error={values.modificationPowerCable.error != null}
                        />
                        <FormControlLabel
                            value="cableRelocation"
                            control={<Radio />}
                            label="Umlegung eines Netzanschlusskabels"
                            text=""
                            error={values.modificationPowerCable.error != null}
                        />
                        <FormControlLabel
                            value="junctionBoxReplacement"
                            control={<Radio />}
                            label="Austausch Hausanschlusskasten"
                            text=""
                            error={values.modificationPowerCable.error != null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
